<div class="action-wrapper">
  @if (canView) {
    <mat-icon class="action-wrapper__icon-button view-icon icon" matTooltip="View" (click)="onViewAction()">visibility</mat-icon>
  }
  @if (canEdit) {
    <img class="action-wrapper__icon-button" matTooltip="Edit" (click)="onEditAction()" class="icon" src="assets/images/btn_edit_action.svg" />
  }
  @if (canDelete) {
    <img class="action-wrapper__icon-button icon" matTooltip="Delete" (click)="onDeleteAction()" src="assets/images/btn_delete_action.svg" />
  }
  @if (canInitiateProject) {
    <mat-icon class="action-wrapper__icon-button" (click)="initiateProject()">slideshow</mat-icon>
  }
  @if (canAssignCoordinator) {
    <mat-icon class="action-wrapper__icon-button add-person-icon" matTooltip="Assign User" (click)="assignCoordinator()">person_add</mat-icon>
  }
  @if (canViewLogs) {
    <mat-icon class="action-wrapper__icon-button history-icon" matTooltip="View Logs" (click)="viewLogs()">history</mat-icon>
  }
  @if (canViewSettings && (userRole==='Super-Admin' || userRole==='Admin')) {
    <mat-icon class="action-wrapper__icon-button setting-icon icon" matTooltip="View Settings" (click)="onViewSettings()">settings</mat-icon>
  }
</div>

<mat-drawer #drawer class="activity-log" mode="side" position="end">
  <button mat-button (click)="closeLogs()" class="activity-btn">
    Close
  </button>

  <p class="head">Activity History</p>
  @if (isLogsOpened) {
    <app-view-activity-logs [projectData]="rowData.project_code"></app-view-activity-logs>
  }
</mat-drawer>